import JwtService from '@/common/jwt.service'

export default function auth(to, from, next) {
  if (!JwtService.getUser()) {
    return next('/login')
  } else {
    const user = JSON.parse(JwtService.getUser())
    let role = user.roles[0].role
    if (role !== 'content_editor' && role !== 'admin') {
      return next('/live_stream')
    }
  }
  return next()
}
